import { render, staticRenderFns } from "./AboutBanner.vue?vue&type=template&id=34002f22&scoped=true&"
import script from "./AboutBanner.vue?vue&type=script&lang=js&"
export * from "./AboutBanner.vue?vue&type=script&lang=js&"
import style0 from "./AboutBanner.vue?vue&type=style&index=0&id=34002f22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34002f22",
  null
  
)

export default component.exports